module.exports = __webpack_public_path__ + "img/71.ab22476e.png";